import { render, staticRenderFns } from "./levelJournal.vue?vue&type=template&id=fdb833d6&scoped=true&"
import script from "./levelJournal.vue?vue&type=script&lang=js&"
export * from "./levelJournal.vue?vue&type=script&lang=js&"
import style0 from "./levelJournal.vue?vue&type=style&index=0&id=fdb833d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb833d6",
  null
  
)

export default component.exports